// removed by extract-text-webpack-plugin
module.exports = {"binary_left_pannel_container":"lcO5pxChabwU50i5f_coU","binary_left_pannel_title":"_3YPRmQ1dYumGunaDVD-Tkg","binary_left_pannel_nav":"_2YoVHPGYcVYyyb-NuSfzDl","binary_left_pannel_body":"_2yTZL8MgSOlQvJYlG8R0DR"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryLeftPannel/BinaryLeftPannel.scss
// module id = 2181
// module chunks = 1